// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"0a1a0b56","551":"9a50127c","673":"0d43aab2"}[chunkId] + ".chunk.css";
};